'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/styles');

var _Button = require('../Button');

var _Typography = require('../Typography');

var _banner = require('../../schema/component/banner.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      alignItems: 'center',
      background: function background(_ref) {
        var _background = _ref.background;
        return _background || 'var(--onprimary-high-emphasis)';
      },
      boxShadow: '0 1px var(--outline)',
      display: function display(_ref2) {
        var variant = _ref2.variant;
        return variant === 'one-line' ? 'flex' : 'inherit';
      },
      justifyContent: 'space-between',
      marginBottom: '1rem',
      padding: function padding(_ref3) {
        var containerPadding = _ref3.containerPadding;
        return containerPadding;
      }
    },
    contentContainer: {
      alignItems: 'center',
      display: 'flex'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginRight: function marginRight(_ref4) {
        var actionMarginRight = _ref4.actionMarginRight;
        return actionMarginRight || '0px';
      }
    },
    betweenButtonSpace: {
      marginRight: '24px'
    }
  };
});

var Banner = exports.Banner = function Banner(_ref5) {
  var actions = _ref5.actions,
      background = _ref5.background,
      image = _ref5.image,
      imageAlt = _ref5.imageAlt,
      text = _ref5.text,
      textVariant = _ref5.textVariant,
      variant = _ref5.variant;

  var _React$useState = _react2.default.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isShow = _React$useState2[0],
      setIsShow = _React$useState2[1];

  var variantProps = _banner.properties[variant] && _banner.properties[variant].properties;
  var variantDefault = _banner.properties['one-line'].properties;
  var variantSelected = variantProps || variantDefault;

  var classes = useStyles({
    variant: variant,
    background: background,
    containerPadding: variantSelected.containerPadding,
    actionMarginRight: variantSelected.actionMarginRight
  });

  var buttonAction = function buttonAction(onClick) {
    return onClick ? onClick() : setIsShow(false);
  };

  var onGetActionClass = function onGetActionClass(index) {
    return index === 0 && actions.length > 1 ? classes[variantSelected.actionClassName] : '';
  };

  return isShow ? _react2.default.createElement(
    'div',
    { className: classes.container + ' banner--container' },
    _react2.default.createElement(
      'div',
      {
        className: classes.contentContainer,
        'data-margin-bottom': variantSelected.contentMarginBottom
      },
      variantSelected.isImage && typeof image === 'string' && _react2.default.createElement('img', {
        src: image,
        alt: imageAlt,
        width: '40px',
        height: '40px',
        loading: 'lazy'
      }),
      variantSelected.isImage && (typeof image === 'undefined' ? 'undefined' : _typeof(image)) === 'object' && image,
      _react2.default.createElement(
        _Typography.Typography,
        {
          variant: textVariant,
          'data-margin-left': variantSelected.contentTextSpace
        },
        text
      )
    ),
    _react2.default.createElement(
      'div',
      { className: classes.buttonContainer },
      actions && actions.map(function (action, index) {
        return _react2.default.createElement(
          _Button.Button,
          {
            key: action.text,
            type: action.type || 'text-primary',
            onClick: function onClick() {
              return buttonAction(action.onClick);
            },
            className: onGetActionClass(index)
          },
          action.text
        );
      })
    )
  ) : null;
};

Banner.defaultProps = {
  background: 'var(--onprimary-high-emphasis)',
  image: null,
  imageAlt: '',
  textVariant: 'textbody2-reguler'
};

Banner.propTypes = {
  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    onClick: _propTypes2.default.func,
    text: _propTypes2.default.string
  })).isRequired,
  background: _propTypes2.default.string,
  image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  imageAlt: _propTypes2.default.string,
  text: _propTypes2.default.string.isRequired,
  textVariant: _propTypes2.default.string,
  variant: _propTypes2.default.oneOf(['one-line', 'two-line', 'two-line-image']).isRequired
};

exports.default = Banner;